import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './tm-ti-basic'
import InputTypeDetailed from './tm-ti-detailed'
import InputTypeWithinLease from './tm-ti-within-lease'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed,
  InputTypeWithinLease
}